import { render, staticRenderFns } from "./AwardedERFx.vue?vue&type=template&id=5e3a5a39&scoped=true&"
import script from "./AwardedERFx.vue?vue&type=script&lang=ts&"
export * from "./AwardedERFx.vue?vue&type=script&lang=ts&"
import style0 from "./AwardedERFx.vue?vue&type=style&index=0&id=5e3a5a39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a5a39",
  null
  
)

export default component.exports